
export const CATEGORIES_FULL_LIST = [
  'member-savings',
  'consumer-checking',
  'consumer-savings',
  'consumer-money',
  'consumer-invest',
  'consumer-loan',
  'consumer-credit',
]; 

export const CATEGORY_MAPPING = { 
  checking: ['consumer-checking'],
  savings: ['consumer-savings', 'consumer-money'],
  borrow: ['consumer-loans', 'consumer-credit'],
  invest: ['consumer-invest']
}